class WechatPay {
  onBridgeReady (params, succeedCallBack, failCallBack) {
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest', params,
      function (res) {
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          succeedCallBack()
        } else {
          failCallBack()
        }
      }
    )
  }

  invoke (params, succeedCallBack, failCallBack=function(){}) {
    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
      }
    } else {
      this.onBridgeReady(params, succeedCallBack, failCallBack)
    }
  }
}

const Pay = new WechatPay()
export default Pay
